import { doc, onSnapshot } from 'firebase/firestore';
import { useState, useEffect } from 'react';
import { db } from '../firebase-config';

export function useDocument(path) {
  const [state, setState] = useState({
    data: {},
    hasLoaded: false,
  });

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, path), (document) => {
      setState({ data: { ...document.data(), id: document.id, uid: document.id }, hasLoaded: true });
    });
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [path]);

  return [state.data, state.hasLoaded];
}
